import * as THREE from 'three';
import View from "../View";
import { MAIN_LOOP_EVENTS } from "../MainLoop";
import CameraUtils from "../../Utils/CameraUtils";
import PlanarLayer from "./Planar/PlanarLayer";

function PlanarView(viewerDiv, extent) {
  var _this = this;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  THREE.Object3D.DefaultUp.set(0, 0, 1); // Setup View

  View.call(this, extent.crs, viewerDiv, options); // Configure camera

  var dim = extent.dimensions();
  var max = Math.max(dim.x, dim.y);
  var camera3D = this.camera.camera3D;
  camera3D.near = 0.1;
  camera3D.far = 2 * max;
  this.camera.camera3D.updateProjectionMatrix();
  var tileLayer = new PlanarLayer('planar', extent, options.object3d, options);
  this.addLayer(tileLayer);
  var p = {
    coord: extent.center(),
    range: max,
    tilt: 20,
    heading: 0
  };
  CameraUtils.transformCameraToLookAtTarget(this, camera3D, p);
  this._fullSizeDepthBuffer = null;
  this.addFrameRequester(MAIN_LOOP_EVENTS.BEFORE_RENDER, function () {
    if (_this._fullSizeDepthBuffer != null) {
      // clean depth buffer
      _this._fullSizeDepthBuffer = null;
    }
  });
  this.tileLayer = tileLayer;
}

PlanarView.prototype = Object.create(View.prototype);
PlanarView.prototype.constructor = PlanarView;

PlanarView.prototype.addLayer = function (layer) {
  return View.prototype.addLayer.call(this, layer, this.tileLayer);
};

export default PlanarView;